export default "/images/b9679de77f1f7a64341dae1dab801517.avif";